/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * The component for Accounts routing
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.0.0
 */
import { Switch } from 'react-router';

import { AccessComponentKeyEnum } from '../../modules/role/constants/guard/guardConstants';
import CorporatePage from '../../pages/CorporatePage/CorporatePage';
import PageNotFound from '../../pages/ErrorPage/PageNotFound';
import PagePersonalAccount from '../../pages/PagePersonalAccount/Loadable';
import { RoutePath } from '../constants/routesConstants';
import PrivateRoute from '../PrivateRoute';

export const AccountsRoute = () => {
    return <Switch>

        {/* List */}
        <PrivateRoute
            exact
            accessKey={AccessComponentKeyEnum.PagePersonalAccount}
            component={PagePersonalAccount}
            path={RoutePath.account}
            wrapper={CorporatePage}
        />

        {/* PageNotFound */}
        <PrivateRoute
            accessKey={AccessComponentKeyEnum.PageNotFound}
            component={PageNotFound}
            path="**"
        />

    </Switch>;
};

export default AccountsRoute;
